import AbstractFilter from '../AbstractFilter';
import { FILTER_EVENT } from '../FilterEvent';

export default class EnhancedTextFilter extends AbstractFilter {
  constructor(...args) {
    super(...args);

    this._getDom();
    this._bind();
  }

  _getDom() {
    this._dom.input = this._dom.container;
  }

  _bind() {
    this._dom.input.addEventListener('focusout', () => {
      const value = this._dom.input.value;
      if (value !== this._values[0]) {
        this._values = [value];
        this.emit(FILTER_EVENT.CHANGED);
      }
    });
    this._dom.input.addEventListener('keypress', (e) => {
      const key = e.which || e.keyCode;
      if (key === 13) {
        this._send();
      }
    });
    this._values = [this._dom.input.value];
  }

  removeAllChoices() {
    this._values = [];
    this._dom.input.value = '';
    this.emit(FILTER_EVENT.CHANGED);
  }

  _send() {
    this._values = [this._dom.input.value];
    this.emit(FILTER_EVENT.CHANGED);
    this.close();
    const el = document.querySelector('.js-submit-search');
    this.triggerEvent(el, 'click');
  }

  triggerEvent(el, type) {
    const e = document.createEvent('HTMLEvents');
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  }

  isMultiple() {
    return false;
  }
}
